import * as React from "react"
import Section from "../../../core/layout/main/section/Section"
import * as classNames from "./BlogNewsletterSubscriptionSection.module.scss"

const BlogNewsletterSubscriptionSection = ({ title, underTitle, form }) => {
  return (
    <Section
      className={` pbl-8 ${classNames.sectionBg}`}
      container="xxlarge"
    >
      <div className={`text-center mb-4`}>
        <h2>{title}</h2>
      </div>
      <p className={`text-center mb-4`}>{underTitle}</p>
      <div
        dangerouslySetInnerHTML={{ __html: form }}
        className={`text-center  ${classNames.FormStyle}`}
      />
    </Section>
  )
}

export const name = "BlogNewsletterSubscriptionSection"

export const init = (componentData, pageContext) => {
  return (
    <BlogNewsletterSubscriptionSection
      key={componentData.id}
      title={
        componentData.newsLetterTitle
          ? componentData.newsLetterTitle
          : "Newsletter"
      }
      underTitle={
        componentData.newsLetterUnderTitle
          ? componentData.newsLetterUnderTitle
          : "Lorem ipsum dolor sit amet, consectetur adipiscing elit nam eu urna ultrices."
      }
      form={componentData.newsLetterForm}
    />
  )
}

export default BlogNewsletterSubscriptionSection
